import { render, staticRenderFns } from "./ZDMFailureStatusAdmin.vue?vue&type=template&id=30c6df80&scoped=true&"
import script from "./ZDMFailureStatusAdmin.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureStatusAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6df80",
  null
  
)

export default component.exports